
import router from '@/router';
import { generalStore } from '@/store';
import { ref, onMounted } from 'vue';
import { OrderDetails, Slot } from '@/models/Order';
import swal from 'sweetalert2';
import Q from 'q';
import useOrder from '@/modules/useOrder';
import { onBeforeRouteLeave } from 'vue-router';
import CalendarKendo from '@/components/Calendar/CalendarKendo.vue';
import { useRoute } from 'vue-router';
import { CalendarSlot } from '@/models/Calendar';
import moment from 'moment';
import { DayOfWeekKendo } from '@/models/Enums';
import { VIRTUAL_SLOT_ID } from '@/models/Constants';

export default {
    components: {
        CalendarKendo
    },
    async setup() {
        const { canLeave, goToSelectProduct, goToSelectCustomerType, goToNewEntityDetails } = useOrder();
        const route = useRoute();
        onBeforeRouteLeave(async to => {
            return await canLeave(to);
        });
        let orderId = '';
        if (route.params.id) {
            orderId = route.params.id.toString();
        }
        let productId = '';
        if (route.params.id) {
            productId = route.params.productId.toString();
        }
        let customerId = '';
        if (route.params.id) {
            customerId = route.params.customerId.toString();
        }
        const loaded = ref(false);
        const order = ref(new OrderDetails());
        const slots = ref<Slot[]>([]);

        function pageDataExist() {
            if (!order.value) {
                return false;
            }
            if (!order.value.priceTypeId) {
                return false;
            }
            if (!order.value.newproduct.productId) {
                return false;
            }
            return true;
        }
        const back = () => {
            goToSelectProduct(order.value.crmCustomerLeadId ? order.value.crmCustomerLeadId : null);
        };

        function getKendoDayOfWeek(date: string | Date): string {
            const dayName = moment(date).format('dddd');
            return DayOfWeekKendo[dayName as keyof typeof DayOfWeekKendo];
        }

        function onselectslot({ slotId, slot, date }: any) {
            order.value.newproduct.date = date;
            order.value.newproduct.slotId = slotId;
            order.value.newproduct.slot = slot;
            order.value.newproduct.startTime = slot.startTime;
            order.value.newproduct.duration = slot.duration;
            order.value.newproduct.customers = [];
            if (!order.value.newproduct.slot.daysOfWeek.length) {
                order.value.newproduct.slot.daysOfWeek = [getKendoDayOfWeek(date)];
            }
            goToSelectCustomerType(order.value.crmCustomerLeadId ? order.value.crmCustomerLeadId : null);
        }

        function onselectvirtualslot(slot: Slot) {
            order.value.newproduct.date = slot.startDate.toString();
            order.value.newproduct.slotId = slot.id;
            order.value.newproduct.slot = slot;
            order.value.newproduct.startTime = slot.startTime;
            order.value.newproduct.duration = slot.duration;
            order.value.newproduct.customers = [];
            if (!order.value.newproduct.slot.daysOfWeek.length) {
                order.value.newproduct.slot.daysOfWeek = [getKendoDayOfWeek(slot.startDate)];
            }
            goToSelectCustomerType(order.value.crmCustomerLeadId ? order.value.crmCustomerLeadId : null);
        }

        const onMountedCall = async () => {
            swal.showLoading();
            await Q.delay(400);
            order.value = generalStore.getters.getNewOrder;
            if (!pageDataExist()) {
                goToNewEntityDetails(order.value);
                swal.close();
                return;
            }
            loaded.value = true;
            swal.close();
        };
        onMounted(onMountedCall);

        swal.close();
        return {
            back,
            order,
            slots,
            onselectslot,
            onselectvirtualslot,
            loaded
        };
    }
};
